import { render, staticRenderFns } from "./HeaderDropdownLang.vue?vue&type=template&id=7f5b1920"
import script from "./HeaderDropdownLang.vue?vue&type=script&lang=js"
export * from "./HeaderDropdownLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports